import { render } from "./ItemDeOpcao.vue?vue&type=template&id=c71baa82&ts=true"
import script from "./ItemDeOpcao.vue?vue&type=script&lang=ts"
export * from "./ItemDeOpcao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__